import GeneralFilter from '../../../../Model/GeneralFilter'

export default class LocationFilter extends GeneralFilter {
  constructor () {
    super()
    this.setInitialValue()
  }

  setInitialValue () {
    this.setFilterInitialValue()
    this.city_id = ''
  }
}
